<template>
  <div style="margin: 0px 20px;">
    <div class="title">客户：
      <!-- <el-button style="float:right" @click="changeUser" type="primary">重新选择客户</el-button> -->
    </div>
    <el-table :data="userDataList" border style="width: 100%;" v-loading="userDataLoading">
      <el-table-column prop="username" header-align="center" align="center" label="登录账号" width="170">
      </el-table-column>
      <el-table-column prop="name" header-align="center" align="center" label="用户姓名" width="140">
      </el-table-column>
      <el-table-column prop="names" header-align="center" align="center" label="部门" width="160">
      </el-table-column>
      <el-table-column prop="email" header-align="center" align="center" label="邮箱" width="170">
      </el-table-column>
      <el-table-column prop="mobile" header-align="center" align="center" label="手机号" width="170">
      </el-table-column>
      <el-table-column prop="sex" header-align="center" align="center" label="性别" width="120">
      </el-table-column>
      <el-table-column prop="status" header-align="center" align="center" label="状态" width="">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status ? 'success' : 'warning'">{{scope.row.status ? '正常' : '禁用'}}</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="customerName" header-align="center" align="center" label="企业名称">
      </el-table-column>
      <el-table-column prop="customerCode" header-align="center" align="center" label="企业编号">
      </el-table-column>
      <el-table-column prop="userNickname" header-align="center" align="center" label="昵称" width="120">
      </el-table-column>
      <el-table-column prop="customerManager" header-align="center" align="center" label="企业管理员账号" width="160">
        <template slot-scope="scope">
          <el-tag :type="scope.row.customerManager ? 'success' : 'warning'">{{scope.row.customerManager ? '是' : '否'}}</el-tag>
        </template>
      </el-table-column> -->
    </el-table>
    <div class="title marginTop20">
      模块：
      <el-select v-model="modularValue" placeholder="请选择" @change="changeModularValue">
        <el-option
          v-for="item in modularOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <!-- <el-button style="float:right" @click="openSendDialog" type="primary">发送预警短信</el-button> -->
    </div>
    <keep-alive :include="includeModularString">
      <modularChild1 v-if="modularValue === 1" :suId="suId" :socUserName="socUserName" :userId="userId" ref="modularChild1"></modularChild1>
      <modularChild2 v-if="modularValue === 2" :socUserName="socUserName"></modularChild2>
      <modularChild3 v-if="modularValue === 3" :socUserName="socUserName"></modularChild3>
      <modularChild4 v-if="modularValue === 4" :socUserName="socUserName"></modularChild4>
      <modularChild5 v-if="modularValue === 5" :socUserName="socUserName"></modularChild5>
      <modularChild6 v-if="modularValue === 6" :socUserName="socUserName"></modularChild6>
      <modularChild7 v-if="modularValue === 7" :socUserName="socUserName"></modularChild7>
      <modularChild8 v-if="modularValue === 8" :socUserName="socUserName"></modularChild8>
      <modularChild9 v-if="modularValue === 9" :socUserName="socUserName"></modularChild9>
      <modularChild10 v-if="modularValue === 10" :socUserName="socUserName"></modularChild10>
      <modularChild11 v-if="modularValue === 11" :socUserName="socUserName"></modularChild11>
      <modularChild12 v-if="modularValue === 12" :socUserName="socUserName"></modularChild12>
      <!-- <modularChild13 v-if="modularValue === 13" :socUserName="socUserName"></modularChild13> -->
    </keep-alive>
    <el-dialog
      :title="dialog.title + '预警短信'"
      :visible.sync="dialog.visible"
      width="30%"
      :before-close="handleClose">
      <div style="padding-bottom: 10px">{{dialog.tel}}</div>
      <el-input
        type="textarea"
        :rows="4"
        :placeholder="dialog.inputPlaceholder"
        v-model="dialog.info">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sendMessage">发送</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import selectOptions from './selectOption';
export default {
  mixins: [selectOptions],
  components: {
    'modularChild1': () => import('./components/modularChild1'),
    'modularChild2': () => import('./components/modularChild2'),
    'modularChild3': () => import('./components/modularChild3'),
    'modularChild4': () => import('./components/modularChild4'),
    'modularChild5': () => import('./components/modularChild5'),
    'modularChild6': () => import('./components/modularChild6'),
    'modularChild7': () => import('./components/modularChild7'),
    'modularChild8': () => import('./components/modularChild8'),
    'modularChild9': () => import('./components/modularChild9'),
    'modularChild10': () => import('./components/modularChild10'),
    'modularChild11': () => import('./components/modularChild11'),
    'modularChild12': () => import('./components/modularChild12'),
    // 'modularChild13': () => import('./components/modularChild13')
  },
  data () {
    return {
      userId: this.$store.state.user.id,
      suId: '',
      userDataList: [],
      modularValue: null,
      userDataLoading: true,
      includeModular: ['modularChild1'],
      dialog: {
        visible: false,
        title: '',
        tel: '',
        info: '',
        inputPlaceholder: ''
      }
    }
  },
  computed: {
    includeModularString() {
      return this.includeModular.join(',')
    }
  },
  methods: {
    changeUser() {
      this.$router.push({name: 'socSafe-securityConsole'})
    },
    openSendDialog() {
      this.dialog.title = this.modularOptions[this.modularValue - 1].label
      this.dialog.tel = this.userDataList[0].mobile
      this.dialog.visible = true
    },
    handleClose() {
      this.dialog.visible = false
    },
    sendMessage() {
      if (this.dialog.info) {}
    },
    getOrderInfo(isactivated) {
      // let params = {
      //   userId: this.userId
      // }
      if (isactivated) {
        this.$refs['modularChild1'].clearData()
      }
      this.userDataLoading = true
      this.userDataList = []
      this.$http.get(`/front/consumer/order/soc/user/getByCheckId`)
        .then(data => {
          if (data && data.status === 200 && data.data.code === 0) {                       
            this.suId = data.data.data.suId
            this.modularValue = 1
            this.socUserName = data.data.data.socUserName
            // keep-alive 不知为何不能重载第一个子组件，需要手动更新modularChild1的数据
            if (isactivated) {
              this.$refs['modularChild1'].getData(this.suId)
            }
            this.userDataList.push(data.data.data)
          }
          this.userDataLoading = false
        })
        .catch(() => {
          this.userDataLoading = false
        })
      // this.suId = 1111
      // this.modularValue = 1
      // keep-alive 不知为何不能重载第一个子组件，需要手动更新modularChild1的数据
      // if (isactivated) {
      //   this.$refs['modularChild1'].getData(this.suId)
      // }
      // if (this.$store.getters.userInfo.userId == '25458') {
      //   this.userDataList.push({
      //     names: '工业安全部',
      //     customerName: '杭州良品乐购科技有限公司',
      //     customerCode: 'SSIT879766',
      //     username: '13588089664',
      //     name: '李茂良',
      //     userNickname: '李茂良',
      //     mobile: '13588089664'
      //   })
      // }
      // if (this.$store.getters.userInfo.userId == '25431') {
      //   this.userDataList.push({
      //     names: '信息科',
      //     customerName: '浙江工自仪网络有限公司',
      //     customerCode: 'SSIT776890',
      //     username: 'qyzh18072734032',
      //     name: '王帅',
      //     userNickname: '王帅',
      //     mobile: '18072734032'
      //   })
      // }
      // this.userDataLoading = false
    },
    changeModularValue() {
      if (!this.socUserName) {
        this.$message.error('请先绑定SOC用户')
        this.modularValue = 1
        return
      }
      this.dialog.inputPlaceholder = `您的${this.modularOptions[this.modularValue - 1].label}有新预警消息，请登录宁东工业超市账户SAAS板块查询！`
      if (!this.includeModular.includes(`modularChild${this.modularValue}`)) {
        this.includeModular.push(`modularChild${this.modularValue}`)
      }
    }
  },
  activated() {
    if (this.$route.query.userId !== undefined && this.userId !== this.$route.query.userId) {
      this.dialog = {
        visible: false,
        title: '',
        tel: '',
        info: '',
        inputPlaceholder: ''
      }
      this.includeModular = ['modularChild1']
      this.getOrderInfo(true)
    }
  },
  mounted() {
    if (this.$route.query.userId !== undefined && this.userId !== this.$route.query.userId) {
      this.userId = this.$route.query.userId
    }
    this.getOrderInfo()
  }
}
</script>

<style scoped>
.title {
  line-height: 40px;
  font-size: 16px;
}
.marginTop20 {
  margin-top: 20px;
}
</style>